
import { reject } from "lodash";
import { Component, Vue, Watch } from "vue-property-decorator";
import { RegisteredCrudStore } from "@/libs/core/crud/register-crud-store";
import { CrudAction, CrudResponseAction } from "@/libs/core/crud/crud-action";

type Dictionary<T> = { [key: string]: T }

@Component({
  components: {
  },
})
export default class Page extends Vue {

    private query: Dictionary<string | (string | null)[]> = {};
    private params: Dictionary<string> = {};

    @Watch("$route")
    routeChanged () {
        this.query = this.$router.currentRoute.query;
        this.params = this.$router.currentRoute.params;
    }

    mounted () {
        this.query = this.$router.currentRoute.query;
        this.params = this.$router.currentRoute.params;
    }

    subscribe (store: RegisteredCrudStore<any>, action: CrudAction, key: string | null = null) : Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const subscribtion = this.$store.subscribe((mutation, _state) => {
                const payloadKey = mutation.payload.key;
                if (payloadKey != key && payloadKey && key)
                    return;
                switch (action) {
                    case CrudAction.GetAll:
                        if (mutation.type === store.getActionName(CrudResponseAction.GetAllSuccess)) {
                            resolve(mutation.payload.data);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.GetAllNoop)) {
                            resolve(mutation.payload.data);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.GetAllFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                    case CrudAction.Get:
                        if (mutation.type === store.getActionName(CrudResponseAction.GetSuccess)) {
                            resolve(mutation.payload.item);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.GetFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
										case CrudAction.GetGrouped:
												if (mutation.type === store.getActionName(CrudResponseAction.GetGroupedSuccess)) {
													resolve(mutation.payload.item);
													subscribtion();
												}
												else if (mutation.type === store.getActionName(CrudResponseAction.GetGroupedFailed)) {
													reject(mutation.payload);
													subscribtion();
												}
												break;
                    case CrudAction.Create:
                        if (mutation.type === store.getActionName(CrudResponseAction.CreateSuccess)) {
                            resolve(mutation.payload.item);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.CreateFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                    case CrudAction.Update:
                        if (mutation.type === store.getActionName(CrudResponseAction.UpdateSuccess)) {
                            resolve(mutation.payload.item);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.UpdateFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                    case CrudAction.PartialUpdate:
                        if (mutation.type === store.getActionName(CrudResponseAction.PartialUpdateSuccess)) {
                            resolve(mutation.payload.item);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.PartialUpdateFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                    case CrudAction.Delete:
                        if (mutation.type === store.getActionName(CrudResponseAction.DeleteSuccess)) {
                            resolve(mutation.payload.data);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.DeleteFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                    case CrudAction.Download:
                        if (mutation.type === store.getActionName(CrudResponseAction.DownloadSuccess)) {
                            resolve(mutation.payload.data);
                            subscribtion();
                        }
                        else if (mutation.type === store.getActionName(CrudResponseAction.DownloadFailed)) {
                            reject(mutation.payload);
                            subscribtion();
                        }
                        break;
                }
            });
        });
    }

    setQuery (q: string, v: string | null) {
        if (v == null || v.length == 0 || v == "null") {
            if (this.query[q]) {
                delete this.query[q];
            }
        }
        else {
            this.query[q] = v.toString();
        }
        this.replaceRoute();
    }

    getQuery (q: string): string | null {
        const currentRoute = this.$router.currentRoute;
        if (currentRoute.query[q] && currentRoute.query[q]?.length > 0 && currentRoute.query[q] != "null") {
            return currentRoute.query[q].toString();
        }
        return null;
    }

    getQueryInt (q: string): number | null {
        var v = this.getQuery(q);
        if (v && !isNaN(Number(v!)))
            return Number(v);
        return null;
    }

    private replaceRoute () {
        var value: Dictionary<string | (string | null)[]> = {};
        var keys = Object.keys(this.query);
        keys.forEach((k) => {
            if (this.query[k] && this.query[k]?.length > 0) {
                value[k] = this.query[k].toString();
            }
        })
        value["t"] = new Date().getTime().toString();
        this.$router.replace({
            name: this.$router.currentRoute.name!,
            params: this.$router.currentRoute.params,
            query: value
        }).catch(err => { console.log(err); });
    }

    getInitials (v: string) {
        let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');

        let initials: any = [...v.matchAll(rgx)] || [];

        initials = (
            (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
        ).toUpperCase();

        return initials;
    }

}
